if (!window.__featureBulletsToggleInitialized) {
  window.__featureBulletsToggleInitialized = true;
  document.addEventListener('click', (event) => {
    const toggleButton = event.target.closest('.feature-bullets-wrapper .show-more-button');
    if (!toggleButton) {
      return;
    }

    const bulletsWrapper = toggleButton.closest('.feature-bullets-wrapper');
    const shouldExpand = toggleButton.getAttribute('aria-expanded') !== 'true';
    const bulletsList = bulletsWrapper.querySelector('.feature-bullets-list');
    const initialCount = parseInt(bulletsList.getAttribute('data-initial-count'), 10) || 3;
    bulletsList.querySelectorAll('.bullet-item').forEach((item, index) => {
      const isHidden = !shouldExpand && index >= initialCount;
      item.classList.toggle('is-hidden', isHidden);
      item.style.display = isHidden ? 'none' : 'list-item';
    });
    toggleButton.setAttribute('aria-expanded', String(shouldExpand));
    toggleButton.dataset.state = shouldExpand ? 'expanded' : 'collapsed';
    toggleButton.textContent = shouldExpand ? 'Show less' : 'Show more';
  });
}

if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
      this.metafieldImagesData = null;
      this.currentMetafieldImages = [];
      this.variantFeatureBulletsData = null;
      this.variantSkuData = null;
      this.variantAttributesData = null;
      this.variantRestrictedStatesData = null;
      this.variantFreeShippingExcludedData = null;
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.loadMetafieldImagesData();
      this.loadVariantFeatureBulletsData();
      this.loadVariantSkuData();
      this.loadVariantAttributesData();
      this.loadVariantRestrictedStatesData();
      this.loadVariantFreeShippingExcludedData();
      // Load metafield images for the initially selected variant after a short delay
      // This ensures the slider is fully initialized first
      setTimeout(() => {
        if (this.currentVariant) {
          // First, ensure only the current variant's slides and thumbnails have is-active
          // This cleans up any slides/thumbnails from other variants that might have is-active from the initial render
          if (this.currentVariant.featured_media) {
            const mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
            this.ensureOnlyCurrentVariantIsActive(mediaId);
          }
          
          // Now update metafield images (which will add is-active to metafield slides/thumbnails)
          this.updateMetafieldImages();
          this.updateFeatureBullets();
          this.updateSku();
          this.updateAttributes();
          this.updateBubbleAttributes();
          this.updateRestrictedStates();
          this.updateFreeShippingExcluded();
          
          // Reinitialize slider to include metafield images, then ensure featured media is selected
          if (this.currentMetafieldImages && this.currentMetafieldImages.length > 0 && this.productSlider && this.productSlider.flkty) {
            this.productSlider.reInit(this.imageSetIndex);
            // After reinit, make sure the featured media is still selected and thumbnail is highlighted
            if (this.currentVariant.featured_media) {
              const mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
              const thumbId = `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
              setTimeout(() => {
                if (this.productSlider.flkty) {
                  // Select the featured media slide
                  this.productSlider.flkty.selectCell(mediaId);
                  // Highlight the correct thumbnail
                  const thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
                  if (thumbnails) {
                    const activeThumb = thumbnails.querySelector(thumbId);
                    if (activeThumb) {
                      // Remove highlight from all thumbnails
                      thumbnails.querySelectorAll('.product-thumbnail').forEach(thumb => {
                        thumb.classList.remove('is-initial-selected');
                      });
                      // Highlight the correct thumbnail
                      activeThumb.classList.add('is-initial-selected');
                    }
                  }
                }
              }, 50);
            }
          } else if (this.productSlider && this.productSlider.flkty) {
            // Even if no metafield images, we should still ensure only current variant is active
            // This handles the case where the initial render had multiple variants with is-active
            if (this.currentVariant.featured_media) {
              const mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
              // Reinitialize to apply the is-active filtering
              this.productSlider.reInit(this.imageSetIndex);
            }
          }
        }
      }, 200);
    setTimeout(() => {
  this.handleQuantityRules();
}, 0);
    }

    onVariantChange(event) {
      if (this.usesOptionValues()) {
        this.onVariantChangeOptionValues(event);
        return;
      }

      this.updateOptions();
      this.updateMasterId();

      // When the selected combination does not exist (e.g. Strip + 8 ft. Radius),
      // switch sibling options to the nearest matching available variant so
      // availability cross-outs stay accurate.
      if (!this.currentVariant && this.selectNearestAvailableVariant(event)) {
        this.updateOptions();
        this.updateMasterId();
      }

      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        // Update metafield images first, then set the active media
        // This ensures all images are in place before selecting the featured media
        this.updateMetafieldImages();
        this.updateFeatureBullets();
        this.updateSku();
        this.updateAttributes();
        this.updateBubbleAttributes();
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
          this.updateDocumentSeo();
        }
        this.updateVariantInput();
        this.updateBloomreachAddToCartAttrs();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      this.handleQuantityRules();
      this.updateRestrictedStates();
      this.updateFreeShippingExcluded();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      if (this.updateMasterIdFromSelectedVariant()) {
        return;
      }

      if (!this.getVariantData()) {
        return;
      }
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    usesOptionValues() {
      const el = this.querySelector('[data-value-id]');
      return !!(el && el.dataset.valueId);
    }

    updateMasterIdFromSelectedVariant() {
      const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
      if (!span) return false;

      const variantId = parseInt(span.dataset.variantId, 10);
      if (!variantId) {
        this.currentVariant = null;
        return true;
      }

      this.currentVariant = {
        id: variantId,
        available: span.dataset.available === 'true',
        featured_media: span.dataset.featuredMediaId
          ? { id: parseInt(span.dataset.featuredMediaId, 10) }
          : null
      };
      return true;
    }

    getSelectedValueIds() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      return this.fieldsets
        .map((fieldset) => {
          const select = fieldset.querySelector('select');
          if (select) {
            return select.selectedOptions[0]?.dataset.valueId;
          }
          return fieldset.querySelector('input:checked')?.dataset.valueId;
        })
        .filter(Boolean);
    }

    syncOptionAvailabilityFromSource(sourceSelects) {
      if (!sourceSelects) return;

      sourceSelects.querySelectorAll('[data-value-id]').forEach((sourceEl) => {
        const valueId = sourceEl.dataset.valueId;
        const available = sourceEl.dataset.available;
        [this, ...this.other].forEach((el) => {
          const localEl = el.querySelector(`[data-value-id="${valueId}"]`);
          if (localEl) {
            localEl.dataset.available = available;
          }
        });
      });
    }

    reconcileUnavailableSelectedOptions() {
      let changed = false;

      this.fieldsets.forEach((fieldset) => {
        const select = fieldset.querySelector('select');
        if (select) {
          const selected = select.selectedOptions[0];
          if (selected && selected.dataset.available === 'false') {
            const replacement = Array.from(select.options).find(
              (opt) => opt.dataset.available !== 'false'
            );
            if (replacement && select.value !== replacement.value) {
              select.value = replacement.value;
              changed = true;
            }
          }
          return;
        }

        const checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!checked || checked.dataset.available !== 'false') return;

        const replacement = Array.from(
          fieldset.querySelectorAll('input[type="radio"]')
        ).find((input) => input.dataset.available !== 'false');

        if (replacement && replacement !== checked) {
          replacement.checked = true;
          changed = true;
        }
      });

      if (changed) {
        this.updateOptions();
        this.updateVariantText();
      }

      return changed;
    }

    onVariantChangeOptionValues(event) {
      this.updateOptions();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
      this.updateVariantText();
      this.renderVariantInfoOptionValues(event);
    }

    renderVariantInfoOptionValues(event) {
      const ids = this.getSelectedValueIds();
      if (!ids.length) return;

      const scrollY = window.scrollY;
      const reconcileDepth = this._optionValuesReconcileDepth || 0;

      fetch(
        `${this.dataset.url}?option_values=${ids.join(',')}&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);
          const sourceSelects = html.getElementById(
            `variant-selects-${this.dataset.section}`
          );

          if (span && parseInt(span.dataset.variantId, 10)) {
            this.currentVariant = {
              id: parseInt(span.dataset.variantId, 10),
              available: span.dataset.available === 'true',
              featured_media: span.dataset.featuredMediaId
                ? { id: parseInt(span.dataset.featuredMediaId, 10) }
                : null
            };
          } else {
            this.currentVariant = null;
          }

          if (
            span &&
            span.dataset.productUrl &&
            span.dataset.productUrl !== this.dataset.url
          ) {
            window.location.href = span.dataset.productUrl;
            return;
          }

          this.syncOptionAvailabilityFromSource(sourceSelects);

          if (!this.currentVariant) {
            if (
              reconcileDepth < 3 &&
              this.reconcileUnavailableSelectedOptions()
            ) {
              this._optionValuesReconcileDepth = reconcileDepth + 1;
              this.renderVariantInfoOptionValues(event);
              return;
            }

            this._optionValuesReconcileDepth = 0;
            this.setDisabled();
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
            window.scrollTo({ top: scrollY, behavior: 'instant' });
            this.updateOther();
            this.updateRestrictedStates();
            this.updateFreeShippingExcluded();
            dispatchCustomEvent('product:variant-change', {
              variant: this.currentVariant,
              sectionId: this.dataset.section
            });
            return;
          }

          this._optionValuesReconcileDepth = 0;

          const selectedSpan = this.querySelector(
            `#SelectedVariant-${this.dataset.section}`
          );
          if (selectedSpan && span) {
            selectedSpan.dataset.variantId = span.dataset.variantId || '';
            selectedSpan.dataset.available = span.dataset.available || '';
            selectedSpan.dataset.featuredMediaId =
              span.dataset.featuredMediaId || '';
            selectedSpan.dataset.productUrl = span.dataset.productUrl || '';
          }

          this.getSectionsToRender().forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
            }
            if (id.includes('price') && destination) {
              destination.classList.remove('visibility-hidden');
            }
          });

          this.setDisabled();
          this.updateVariantInput();
          this.updateBloomreachAddToCartAttrs();
          if (this.updateUrl) {
            this.updateURL();
            this.updateDocumentSeo();
          }
          this.toggleAddButton(
            !this.currentVariant.available,
            window.theme.variantStrings.soldOut
          );
          this.updateMetafieldImages();
          this.updateFeatureBullets();
          this.updateSku();
          this.updateAttributes();
          this.updateBubbleAttributes();
          this.updateMedia();
          this.updatePickupAvailability();
          this.handleQuantityRules();
          this.updateRestrictedStates();
          this.updateFreeShippingExcluded();
          window.scrollTo({ top: scrollY, behavior: 'instant' });
          this.updateOther();
          dispatchCustomEvent('product:variant-change', {
            variant: this.currentVariant,
            sectionId: this.dataset.section
          });
        });
    }

    /**
     * When the current option combination is invalid, pick the closest valid
     * variant that keeps the option the shopper just changed.
     * @returns {boolean} whether inputs were updated
     */
    selectNearestAvailableVariant(event) {
      const variants = this.getVariantData();
      if (!variants || !variants.length || !this.options || !this.options.length) {
        return false;
      }

      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));

      let changedIndex = 0;
      if (event && event.target) {
        const fieldset = event.target.closest('fieldset');
        const idx = this.fieldsets.indexOf(fieldset);
        if (idx > -1) changedIndex = idx;
      }

      const changedValue = this.options[changedIndex];
      let bestVariant = null;
      let bestScore = -1;

      variants.forEach((variant) => {
        if (!variant || !variant.options) return;
        if (variant.options[changedIndex] !== changedValue) return;

        let score = 0;
        for (let i = 0; i < this.options.length; i++) {
          if (i === changedIndex) continue;
          if (variant.options[i] === this.options[i]) score += 1;
        }
        if (variant.available) score += 0.5;

        if (score > bestScore) {
          bestScore = score;
          bestVariant = variant;
        }
      });

      if (!bestVariant) {
        bestVariant = variants.find((variant) => variant && variant.options && variant.options[changedIndex] === changedValue) || null;
      }

      if (!bestVariant) return false;

      let updated = false;
      this.fieldsets.forEach((fieldset, i) => {
        const value = bestVariant.options[i];
        if (value == null) return;

        const select = fieldset.querySelector('select');
        if (select) {
          if (select.value !== value) {
            select.value = value;
            updated = true;
          }
          return;
        }

        const inputs = Array.from(fieldset.querySelectorAll('input'));
        const match = inputs.find((input) => input.value === value);
        if (match && !match.checked) {
          match.checked = true;
          updated = true;
        }
      });

      return updated;
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }
    loadMetafieldImagesData() {
      const stickySuffix = this.sticky ? '--sticky' : '';
      const scriptId = `variant-metafield-images-${this.dataset.section}${stickySuffix}`;
      const metafieldImagesScript = document.getElementById(scriptId);
      if (metafieldImagesScript) {
        try {
          const jsonText = metafieldImagesScript.textContent.trim();
          this.metafieldImagesData = JSON.parse(jsonText);
        } catch (e) {
          this.metafieldImagesData = {};
        }
      } else {
        this.metafieldImagesData = {};
      }
    }

    loadVariantFeatureBulletsData() {
      const scriptId = `variant-featurebullets-${this.dataset.section}`;
      const featureBulletsScript = document.getElementById(scriptId);
      if (featureBulletsScript) {
        try {
          const jsonText = featureBulletsScript.textContent.trim();
          this.variantFeatureBulletsData = JSON.parse(jsonText);
        } catch (e) {
          this.variantFeatureBulletsData = {};
        }
      } else {
        this.variantFeatureBulletsData = {};
      }
    }

    updateFeatureBullets() {
      if (!this.currentVariant || !this.variantFeatureBulletsData) {
        return;
      }

      const bulletsWrapper = this.productWrapper.querySelector('.feature-bullets-wrapper');
      if (!bulletsWrapper) {
        return;
      }
//start (updated section 2026-02-04)
      const variantIdNum = this.currentVariant.id;
      const variantIdStr = variantIdNum.toString();
      const variantBulletsRaw = this.variantFeatureBulletsData[variantIdStr] || this.variantFeatureBulletsData[variantIdNum];

      // Get product bullets from data attribute
      const productBulletsRaw = bulletsWrapper.dataset.productBullets || '';
      // FIX: Added check for the string 'null'
      const productBulletsArray = (productBulletsRaw && productBulletsRaw !== 'null') ? productBulletsRaw.split('|').map(b => b.trim()).filter(b => b) : [];
      
      // Parse variant bullets
      // FIX: Added check for the string 'null'
      const variantBulletsArray = (variantBulletsRaw && variantBulletsRaw !== 'null') ? variantBulletsRaw.split('|').map(b => b.trim()).filter(b => b) : [];
      
      // Find unique variant bullets (not in product bullets)
      const uniqueVariantBullets = variantBulletsArray.filter(variantBullet => {
        return !productBulletsArray.some(productBullet => productBullet === variantBullet);
      });

      // Combine: unique variant bullets first, then product bullets
      const allBulletsArray = [...uniqueVariantBullets, ...productBulletsArray];
      const restrictedStatesValue = this.variantRestrictedStatesData
        ? this.variantRestrictedStatesData[variantIdStr]
        : '';
      const restrictedStates = Array.isArray(restrictedStatesValue)
        ? restrictedStatesValue.join(', ')
        : String(restrictedStatesValue || '').trim();
      const restrictedStatesBullet = restrictedStates
        ? `This item cannot be shipped to: ${restrictedStates}`
        : '';
      if (restrictedStatesBullet && !allBulletsArray.includes(restrictedStatesBullet)) {
        allBulletsArray.unshift(restrictedStatesBullet);
      }
//end (updated section 2026-02-04)

      const bulletsList = bulletsWrapper.querySelector('.feature-bullets-list');
      if (!bulletsList) {
        return;
      }

      // Remove existing bullet items
      const existingItems = bulletsList.querySelectorAll('.bullet-item');
      existingItems.forEach(item => item.remove());

      // Add new bullet items
      const initialCount = parseInt(bulletsList.getAttribute('data-initial-count'), 10) || 3;
      allBulletsArray.forEach((bullet, index) => {
        const isVariantBullet = uniqueVariantBullets.includes(bullet);
        const isRestrictedStatesBullet = bullet === restrictedStatesBullet;
        const isHidden = index >= initialCount;
        const li = document.createElement('li');
        li.className = `bullet-item ${isHidden ? 'is-hidden' : ''} ${isVariantBullet ? 'bullet-item--variant' : ''} ${isRestrictedStatesBullet ? 'bullet-item--restricted-states' : ''}`;
        if (isRestrictedStatesBullet) {
          li.dataset.restrictedStatesBullet = 'true';
        }
        li.setAttribute('data-bullet-text', bullet);
        li.style.display = isHidden ? 'none' : 'list-item';
        li.textContent = bullet;
        bulletsList.appendChild(li);
      });

      // Update show more/less button
      const showMoreButton = bulletsWrapper.querySelector('.show-more-button');
      if (showMoreButton) {
        showMoreButton.type = 'button';
        showMoreButton.setAttribute('aria-expanded', 'false');
        if (allBulletsArray.length > initialCount) {
          showMoreButton.classList.remove('is-hidden');
          showMoreButton.style.display = '';
          showMoreButton.textContent = 'Show more';
          showMoreButton.setAttribute('data-state', 'collapsed');
        } else {
          showMoreButton.classList.add('is-hidden');
          showMoreButton.style.display = 'none';
          showMoreButton.setAttribute('data-state', 'collapsed');
        }
      }
    }

    loadVariantSkuData() {
      const scriptId = `variant-sku-${this.dataset.section}`;
      const variantSkuScript = document.getElementById(scriptId);
      if (variantSkuScript) {
        try {
          const jsonText = variantSkuScript.textContent.trim();
          this.variantSkuData = JSON.parse(jsonText);
        } catch (e) {
          this.variantSkuData = {};
        }
      } else {
        this.variantSkuData = {};
      }
    }

    updateSku() {
      if (!this.currentVariant || !this.variantSkuData) {
        return;
      }

      const skuElement = this.productWrapper.querySelector('.product-sku--custom');
      if (!skuElement) {
        return;
      }

      const variantIdNum = this.currentVariant.id;
      const variantIdStr = variantIdNum.toString();
      const variantSku = this.variantSkuData[variantIdStr] || this.variantSkuData[variantIdNum];

      // Update SKU text (keep "SKU: " prefix)
      if (variantSku && variantSku.trim() !== '') {
        skuElement.textContent = `SKU: ${variantSku}`;
        skuElement.style.display = '';
      } else {
        // Hide if no SKU
        skuElement.style.display = 'none';
      }
    }

    loadVariantAttributesData() {
      const scriptId = `variant-attributes-${this.dataset.section}`;
      const variantAttributesScript = document.getElementById(scriptId);
      if (variantAttributesScript) {
        try {
          const jsonText = variantAttributesScript.textContent.trim();
          this.variantAttributesData = JSON.parse(jsonText);
        } catch (e) {
          this.variantAttributesData = {};
        }
      } else {
        this.variantAttributesData = {};
      }
    }

    loadVariantRestrictedStatesData() {
      const scriptId = `variant-restricted-states-${this.dataset.section}`;
      const restrictedStatesScript = document.getElementById(scriptId);
      if (restrictedStatesScript) {
        try {
          this.variantRestrictedStatesData = JSON.parse(restrictedStatesScript.textContent.trim());
        } catch (e) {
          this.variantRestrictedStatesData = {};
        }
      } else {
        this.variantRestrictedStatesData = {};
      }
    }

    updateRestrictedStates() {
      const restrictedStatesElement = this.productWrapper.querySelector('[data-product-restricted-states]');
      if (!restrictedStatesElement) {
        return;
      }

      const statesElement = restrictedStatesElement.querySelector('[data-restricted-states]');
      if (!statesElement) {
        return;
      }

      const bulletsList = this.productWrapper.querySelector('.feature-bullets-list');
      const currentRestrictionBullet = bulletsList && bulletsList.querySelector('[data-restricted-states-bullet]');
      if (!this.currentVariant && currentRestrictionBullet) {
        currentRestrictionBullet.remove();
      }

      const variantId = this.currentVariant && this.currentVariant.id;
      const restrictedStatesValue = variantId && this.variantRestrictedStatesData
        ? this.variantRestrictedStatesData[String(variantId)]
        : '';
      const restrictedStates = Array.isArray(restrictedStatesValue)
        ? restrictedStatesValue.join(', ')
        : String(restrictedStatesValue || '').trim();

      statesElement.textContent = restrictedStates;
      const restrictionBullet = bulletsList && bulletsList.querySelector('[data-restricted-states-bullet]');
      restrictedStatesElement.hidden = !restrictedStates || Boolean(restrictionBullet);
    }

    loadVariantFreeShippingExcludedData() {
      const scriptId = `variant-free-shipping-excluded-${this.dataset.section}`;
      const freeShippingExcludedScript = document.getElementById(scriptId);
      if (freeShippingExcludedScript) {
        try {
          this.variantFreeShippingExcludedData = JSON.parse(freeShippingExcludedScript.textContent.trim());
        } catch (e) {
          this.variantFreeShippingExcludedData = {};
        }
      } else {
        this.variantFreeShippingExcludedData = {};
      }
    }

    updateFreeShippingExcluded() {
      const messageElement = this.productWrapper.querySelector('[data-free-shipping-excluded]');
      if (!messageElement) {
        return;
      }

      const variantId = this.currentVariant && this.currentVariant.id;
      const isExcluded = Boolean(
        variantId && this.variantFreeShippingExcludedData &&
        this.variantFreeShippingExcludedData[String(variantId)] === true
      );

      messageElement.hidden = !isExcluded;
    }

    updateAttributes() {
      if (!this.currentVariant || !this.variantAttributesData) {
        return;
      }

      // Try to find attributes wrapper - check both in productWrapper and document
      let attributesWrapper = this.productWrapper.querySelector('.attributes-wrapper');
      if (!attributesWrapper) {
        // Try searching in the entire document (in case it's outside productWrapper)
        attributesWrapper = document.querySelector('.attributes-wrapper');
      }
      if (!attributesWrapper) {
        return;
      }

      // Get product attributes from data attribute
      const productAttributesRaw = attributesWrapper.dataset.productAttributes || '';
      
      // Get variant attributes
      const variantIdNum = this.currentVariant.id;
      const variantIdStr = variantIdNum.toString();
      const variantAttributesRaw = this.variantAttributesData[variantIdStr] || this.variantAttributesData[variantIdNum];

      // Parse product attributes
      let productAttributes = {};
      if (productAttributesRaw && productAttributesRaw.trim() !== '') {
        try {
          // Handle both string and object formats
          if (typeof productAttributesRaw === 'string') {
            productAttributes = JSON.parse(productAttributesRaw);
          } else {
            productAttributes = productAttributesRaw;
          }
        } catch (e) {
          // If parsing fails, try manual parsing like Liquid does
          const cleaned = productAttributesRaw.replace(/^{"/, '').replace(/"}$/, '').replace(/":"/g, '::').replace(/","/g, '||');
          const pairs = cleaned.split('||');
          pairs.forEach(pair => {
            const [key, value] = pair.split('::');
            if (key && value) {
              productAttributes[key] = value;
            }
          });
        }
      }

      // Parse variant attributes
      let variantAttributes = {};
      if (variantAttributesRaw && variantAttributesRaw.trim() !== '') {
        try {
          // Handle both string and object formats
          if (typeof variantAttributesRaw === 'string') {
            variantAttributes = JSON.parse(variantAttributesRaw);
          } else {
            variantAttributes = variantAttributesRaw;
          }
        } catch (e) {
          // If parsing fails, try manual parsing like Liquid does
          const cleaned = variantAttributesRaw.replace(/^{"/, '').replace(/"}$/, '').replace(/":"/g, '::').replace(/","/g, '||');
          const pairs = cleaned.split('||');
          pairs.forEach(pair => {
            const [key, value] = pair.split('::');
            if (key && value) {
              variantAttributes[key] = value;
            }
          });
        }
      }

      // Find unique variant attributes (keys not in product attributes)
      const uniqueVariantAttributes = {};
      Object.keys(variantAttributes).forEach(key => {
        if (!productAttributes.hasOwnProperty(key)) {
          uniqueVariantAttributes[key] = variantAttributes[key];
        }
      });

      // Combine: unique variant attributes first, then product attributes
      const allAttributes = { ...uniqueVariantAttributes, ...productAttributes };

      // Remove existing attribute blocks
      const existingBlocks = attributesWrapper.querySelectorAll('.attribute-block');
      existingBlocks.forEach(block => block.remove());

      // Add new attribute blocks
      Object.keys(allAttributes).forEach(key => {
        const value = allAttributes[key];
        const isVariantAttribute = uniqueVariantAttributes.hasOwnProperty(key);

        const attributeBlock = document.createElement('div');
        attributeBlock.className = 'attribute-block';

        const attributeKey = document.createElement('div');
        attributeKey.className = 'attribute-key';
        attributeKey.textContent = key;

        const attributeValue = document.createElement('div');
        attributeValue.className = 'attribute-value';
        attributeValue.textContent = value;

        attributeBlock.appendChild(attributeKey);
        attributeBlock.appendChild(attributeValue);
        attributesWrapper.appendChild(attributeBlock);
      });
    }

    updateBubbleAttributes() {
      if (!this.currentVariant || !this.variantAttributesData) {
        return;
      }

      // Try to find bubble container - check both in productWrapper and document
      let bubbleContainer = this.productWrapper.querySelector('.attributes-bubble-container');
      if (!bubbleContainer) {
        bubbleContainer = document.querySelector('.attributes-bubble-container');
      }
      if (!bubbleContainer) {
        return;
      }

      // Get product attributes from data attribute
      const productAttributesRaw = bubbleContainer.dataset.productAttributes || '';
      const allowedAttributesStr = bubbleContainer.dataset.allowedAttributes || '';
      const allowedAttributes = allowedAttributesStr ? allowedAttributesStr.split(',').map(a => a.trim()) : [];
      const maxBubbles = 6;
      
      // Get variant attributes
      const variantIdNum = this.currentVariant.id;
      const variantIdStr = variantIdNum.toString();
      const variantAttributesRaw = this.variantAttributesData[variantIdStr] || this.variantAttributesData[variantIdNum];

      // Parse product attributes
      let productAttributes = {};
      if (productAttributesRaw && productAttributesRaw.trim() !== '') {
        try {
          if (typeof productAttributesRaw === 'string') {
            productAttributes = JSON.parse(productAttributesRaw);
          } else {
            productAttributes = productAttributesRaw;
          }
        } catch (e) {
          const cleaned = productAttributesRaw.replace(/^{"/, '').replace(/"}$/, '').replace(/":"/g, '::').replace(/","/g, '||');
          const pairs = cleaned.split('||');
          pairs.forEach(pair => {
            const [key, value] = pair.split('::');
            if (key && value) {
              productAttributes[key.trim()] = value.trim();
            }
          });
        }
      }

      // Parse variant attributes
      let variantAttributes = {};
      if (variantAttributesRaw && variantAttributesRaw.trim() !== '') {
        try {
          if (typeof variantAttributesRaw === 'string') {
            variantAttributes = JSON.parse(variantAttributesRaw);
          } else {
            variantAttributes = variantAttributesRaw;
          }
        } catch (e) {
          const cleaned = variantAttributesRaw.replace(/^{"/, '').replace(/"}$/, '').replace(/":"/g, '::').replace(/","/g, '||');
          const pairs = cleaned.split('||');
          pairs.forEach(pair => {
            const [key, value] = pair.split('::');
            if (key && value) {
              variantAttributes[key.trim()] = value.trim();
            }
          });
        }
      }

      // Combine: variant attributes override product attributes (variant first, then product)
      const allAttributes = { ...productAttributes, ...variantAttributes };

      // Filter by allowed attributes and limit to maxBubbles
      const filteredAttributes = [];
      Object.keys(allAttributes).forEach(key => {
        if (allowedAttributes.length === 0 || allowedAttributes.includes(key)) {
          filteredAttributes.push({ key, value: allAttributes[key] });
        }
      });

      // Limit to maxBubbles
      const displayAttributes = filteredAttributes.slice(0, maxBubbles);

      // Remove existing bubbles
      const existingBubbles = bubbleContainer.querySelectorAll('.attribute-bubble');
      existingBubbles.forEach(bubble => bubble.remove());

      // Icon SVG templates
      const iconTemplates = {
        'Connection Size': '<svg class="bubble-icon" xmlns="www.w3.org" height="24" viewBox="0 0 24 24" width="24" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 3h2v6h-2V9zm-4 0h2v6H7V9zm8 0h2v6h-2V9z"/></svg>',
        'Dimensions': '<svg class="bubble-icon" xmlns="www.w3.org" height="24" viewBox="0 0 24 24" width="24" fill="currentColor"><path d="M0 0h24v24H0z" fill="none"/><path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 3h2v6h-2V9zm-4 0h2v6H7V9zm8 0h2v6h-2V9z"/></svg>',
        'Bulb Shape': '<svg class="bubble-icon" viewBox="0 0 16 16" xmlns="www.w3.org" fill="currentColor"><path d="M8 0a.75.75 0 01.75.75v1a.75.75 0 01-1.5 0v-1A.75.75 0 018 0zM13.28 2.22a.75.75 0 010 1.06l-.707.707a.75.75 0 11-1.06-1.06l.707-.707a.75.75 0 011.06 0zM2.72 3.28a.75.75 0 011.06-1.06l.707.707a.75.75 0 01-1.06 1.06L2.72 3.28zM15.5 7.5a.75.75 0 01-.75.75h-1a.75.75 0 010-1.5h1a.75.75 0 01.75.75zM2.25 8.25a.75.75 0 000-1.5h-1a.75.75 0 000 1.5h1zM6.25 15.25A.75.75 0 017 14.5h2A.75.75 0 019 16H7a.75.75 0 01-.75-.75z"></path><path d="M8 3.5A4.5 4.5 0 003.5 8c0 1.53.926 2.465 1.718 3.264l.2.203c.05.05.081.124.081.208.001 1.008.818 1.825 1.826 1.825H8.69c1 0 1.811-.81 1.811-1.81 0-.083.033-.159.088-.213l.067-.066C11.492 10.592 12.5 9.605 12.5 8A4.5 4.5 0 008 3.5zM5 8a3 3 0 016 0c0 .928-.54 1.502-1.462 2.406-.347.34-.538.803-.538 1.283a.31.31 0 01-.31.311H7.324A.326.C.326 0 017 11.674c0-.461-.175-.914-.507-1.255l-.115-.117C5.49 9.397 5 8.894 5 8z"></path></svg>',
        'Lighting Technology': '<svg class="bubble-icon" viewBox="0 0 16 16" xmlns="www.w3.org" fill="currentColor"><path d="M8 0a.75.75 0 01.75.75v1a.75.75 0 01-1.5 0v-1A.75.75 0 018 0zM13.28 2.22a.75.75 0 010 1.06l-.707.707a.75.75 0 11-1.06-1.06l.707-.707a.75.75 0 011.06 0zM2.72 3.28a.75.75 0 011.06-1.06l.707.707a.75.75 0 01-1.06 1.06L2.72 3.28zM15.5 7.5a.75.75 0 01-.75.75h-1a.75.75 0 010-1.5h1a.75.75 0 01.75.75zM2.25 8.25a.75.75 0 000-1.5h-1a.75.75 0 000 1.5h1zM6.25 15.25A.75.75 0 017 14.5h2A.75.75 0 019 16H7a.75.75 0 01-.75-.75z"></path><path d="M8 3.5A4.5 4.5 0 003.5 8c0 1.53.926 2.465 1.718 3.264l.2.203c.05.05.081.124.081.208.001 1.008.818 1.825 1.826 1.825H8.69c1 0 1.811-.81 1.811-1.81 0-.083.033-.159.088-.213l.067-.066C11.492 10.592 12.5 9.605 12.5 8A4.5 4.5 0 008 3.5zM5 8a3 3 0 016 0c0 .928-.54 1.502-1.462 2.406-.347.34-.538.803-.538 1.283a.31.31 0 01-.31.311H7.324A.326.C.326 0 017 11.674c0-.461-.175-.914-.507-1.255l-.115-.117C5.49 9.397 5 8.894 5 8z"></path></svg>',
        'Voltage Rating': '<svg class="bubble-icon" xmlns="www.w3.org" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>',
        'default': '<svg class="bubble-icon" xmlns="www.w3.org" viewBox="0 0 24 24" fill="currentColor"><path d="M20.285 2l-11.285 11.283-5.285-5.283-1.414 1.414 6.7 6.7 12.7-12.742z"/></svg>'
      };

      // Add new bubbles
      displayAttributes.forEach(({ key, value }) => {
        const bubble = document.createElement('div');
        bubble.className = 'attribute-bubble';
        bubble.setAttribute('data-attribute-key', key);

        // Determine which icon to use
        let iconSvg = iconTemplates.default;
        if (key === 'Connection Size' || key === 'Dimensions') {
          iconSvg = iconTemplates['Connection Size'];
        } else if (key === 'Bulb Shape' || key === 'Lighting Technology') {
          iconSvg = iconTemplates['Bulb Shape'];
        } else if (key === 'Voltage Rating') {
          iconSvg = iconTemplates['Voltage Rating'];
        }

        bubble.innerHTML = iconSvg + `
          <div class="bubble-text-wrapper">
            <span class="bubble-key">${key}</span>
            <span class="bubble-value">${value}</span>
          </div>
        `;

        bubbleContainer.appendChild(bubble);
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      const mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      const thumbId = `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`;

      // Before reinitializing, ensure only the correct slides have is-active
      // This prevents wrong variant images from appearing
      this.ensureOnlyCurrentVariantIsActive(mediaId);

      // If metafield images were added, we need to reinitialize the slider first
      // Then set the active media (skip reInit in setActiveMedia to avoid double reinit)
      if (this.currentMetafieldImages && this.currentMetafieldImages.length > 0 && this.productSlider.flkty) {
        // Reinitialize to include new metafield images
        this.productSlider.reInit(this.imageSetIndex);
        // Wait a moment for reInit to complete, then set active media
        this._skipReInit = true;
        setTimeout(() => {
          this.setActiveMedia(mediaId, thumbId, this.productSlider, thumbnails);
          this._skipReInit = false;
        }, 50);
      } else {
        // No metafield images, proceed normally
        this.setActiveMedia(mediaId, thumbId, this.productSlider, thumbnails);
      }
    }

    ensureOnlyCurrentVariantIsActive(mediaId) {
      const thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      // When hiding other variants, only the selected variant's featured media,
      // its metafield images, and product-level videos should be active.
      [].forEach.call(this.productSlider.querySelectorAll('.product-images__slide'), function (el) {
        el.classList.remove('is-active');
      });

      // Add is-active to the featured media slide
      const featuredSlide = this.productSlider.querySelector(mediaId);
      if (featuredSlide) {
        featuredSlide.classList.add('is-active');
      }

      // Ensure current metafield images have is-active
      if (this.currentMetafieldImages) {
        this.currentMetafieldImages.forEach(item => {
          if (item.slide) {
            item.slide.classList.add('is-active');
          }
        });
      }

      this.activateProductVideos();

      // Thumbnails: only current variant featured + metafield + video thumbs
      if (thumbnails) {
        [].forEach.call(thumbnails.querySelectorAll('.product-thumbnail'), function (el) {
          el.classList.remove('is-active');
          el.classList.remove('is-initial-selected');
        });

        const thumbId = mediaId.replace('Slide-', 'Thumb-');
        const featuredThumb = thumbnails.querySelector(thumbId);
        if (featuredThumb) {
          featuredThumb.classList.add('is-active');
        }

        if (this.currentMetafieldImages) {
          this.currentMetafieldImages.forEach(item => {
            if (item.thumb) {
              item.thumb.classList.add('is-active');
            }
          });
        }

        this.activateProductVideoThumbnails(thumbnails);
      }

      this.moveProductVideosToEnd();
    }

    activateProductVideos() {
      if (!this.productSlider) return;
      this.productSlider
        .querySelectorAll('.product-images__slide[data-media-type="video"], .product-images__slide[data-media-type="external_video"]')
        .forEach((slide) => slide.classList.add('is-active'));
    }

    activateProductVideoThumbnails(thumbnails) {
      if (!thumbnails) return;
      thumbnails
        .querySelectorAll('.product-thumbnail[data-media-type="video"], .product-thumbnail[data-media-type="external_video"]')
        .forEach((thumb) => thumb.classList.add('is-active'));
    }

    // Keep videos after the featured image and metafield images so the
    // carousel order is: featured → variant metafield images → videos.
    moveProductVideosToEnd() {
      if (!this.productSlider) return;

      const videoSlides = Array.from(
        this.productSlider.querySelectorAll(
          '.product-images__slide[data-media-type="video"], .product-images__slide[data-media-type="external_video"]'
        )
      );
      videoSlides.forEach((slide) => {
        if (slide.parentNode) slide.parentNode.appendChild(slide);
      });

      const thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      if (!thumbnails) return;

      videoSlides.forEach((slide) => {
        const thumbId = `#${slide.id.replace('Slide-', 'Thumb-')}`;
        const thumb = thumbnails.querySelector(thumbId);
        if (thumb) thumbnails.appendChild(thumb);
      });
    }

    updateMetafieldImages() {
      if (!this.currentVariant || !this.metafieldImagesData) {
        return;
      }

      // Remove previous metafield images
      this.removeMetafieldImages();

      // Get metafield images for current variant
      // Try both string and number versions of the variant ID
      const variantIdNum = this.currentVariant.id;
      const variantIdStr = variantIdNum.toString();
      
      // Check both string and number keys (JSON keys are strings, but let's be safe)
      let metafieldImages = this.metafieldImagesData[variantIdStr] || this.metafieldImagesData[variantIdNum];

      if (metafieldImages && metafieldImages.length > 0) {
        this.addMetafieldImages(metafieldImages);
      }
    }

    removeMetafieldImages() {
      // Remove all existing metafield images
      // Need to search in both the container and inside flickity-slider (if it exists)
      const existingMetafieldSlides = this.productSlider.querySelectorAll('.product-images__slide[data-metafield-image]');
      const existingMetafieldThumbs = this.productWrapper.querySelectorAll('.product-thumbnail[data-metafield-image]');

      existingMetafieldSlides.forEach(slide => {
        // Remove is-active class before removing (in case it's still in DOM)
        slide.classList.remove('is-active');
        // Remove from wherever it is (container or flickity-slider)
        slide.remove();
      });
      existingMetafieldThumbs.forEach(thumb => {
        thumb.classList.remove('is-active');
        thumb.remove();
      });

      this.currentMetafieldImages = [];
    }

    addMetafieldImages(images) {
      if (!this.productSlider || !images || images.length === 0) return;

      const thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      const sectionId = this.dataset.section;
      const mediaAspectRatio = this.productWrapper.dataset.mediaAspectRatio || 'adapt';
      const displayCaptions = this.productWrapper.dataset.displayCaptions === 'true';
      const lightboxEnabled = this.productWrapper.dataset.lightbox !== 'false';
      
      // Get sizes from product wrapper or use defaults
      const productMediaWidth = this.productWrapper.dataset.productMediaWidth || 'medium';
      const sizes = productMediaWidth === 'large' ? '375x,840x,1680x' : '375x,690x,1380x';

      // Metafield images sit directly after the variant's featured media, in
      // metafield order. Each anchor advances to the item just inserted,
      // otherwise every insert lands on the same spot and reverses the list.
      const featuredMediaId = this.currentVariant.featured_media?.id;
      let slideAnchor = featuredMediaId
        ? this.productSlider.querySelector(`#Slide-${sectionId}-${featuredMediaId}`)
        : null;
      let thumbAnchor = featuredMediaId && thumbnails
        ? thumbnails.querySelector(`#Thumb-${sectionId}-${featuredMediaId}`)
        : null;

      images.forEach((image, index) => {
        // Create slide element
        const slide = document.createElement('div');
        slide.id = `Slide-${sectionId}-${image.id}`;
        slide.className = 'product-images__slide is-active product-images__slide-item--metafield';
        slide.setAttribute('data-media-id', `${sectionId}-${image.id}`);
        slide.setAttribute('data-metafield-image', 'true');

        // Match Liquid product-media: aspect_ratio is width/height, then
        // padding-bottom = 1 / aspect_ratio * 100 (i.e. height/width * 100).
        let ratio = 1;
        if (mediaAspectRatio === 'adapt' && image.width && image.height) {
          ratio = image.width / image.height;
        } else if (mediaAspectRatio === 'portrait') {
          ratio = 1 / 1.25;
        } else if (mediaAspectRatio === 'landscape') {
          ratio = 1 / 0.75;
        }
        const paddingBottom = (1 / ratio) * 100;

        // Build srcset
        const srcset = `${image.url375 || image.url} 375w, ${image.url690 || image.url} 690w, ${image.url1380 || image.url} 1380w`;
        const sizesAttr = sizes;

        // Create zoom icon SVG (simplified version)
        const zoomIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.35-4.35"></path></svg>';

        // Create image HTML
        const imageHtml = `
          <div class="product-single__media product-single__media-image aspect-ratio aspect-ratio--${mediaAspectRatio}" 
               id="Media-Thumbnails-${sectionId}-${image.id}" 
               style="--padding-bottom: ${paddingBottom}%;">
            ${lightboxEnabled ? `
            <a href="${image.url}" 
               class="product-single__media-zoom" 
               data-msrc="${image.url375 || image.url}" 
               data-h="${image.height}" 
               data-w="${image.width}" 
               target="_blank" 
               tabindex="-1" 
               title="${image.alt || 'Zoom'}"
               data-index="${this.productSlider.querySelectorAll('.product-images__slide.is-active').length + index}">
              ${zoomIcon}
            </a>
            ` : ''}
            <img class="lazyload no-blur" 
                 data-src="${image.url375 || image.url}" 
                 data-srcset="${srcset}"
                 data-sizes="auto"
                 src="${image.url375 || image.url}"
                 srcset="${srcset}"
                 sizes="${sizesAttr}"
                 alt="${image.alt || ''}"
                 loading="lazy"
                 width="${image.width}"
                 height="${image.height}">
            ${image.alt && displayCaptions ? `<span class="figcaption">${image.alt}</span>` : ''}
          </div>
        `;

        slide.innerHTML = imageHtml;

        // Create thumbnail element
        const thumb = document.createElement('div');
        thumb.id = `Thumb-${sectionId}-${image.id}`;
        thumb.className = 'product-thumbnail is-active product-images__slide-item--metafield';
        thumb.setAttribute('data-metafield-image', 'true');

        const thumbImageHtml = `
          <img src="${image.url128 || image.url375 || image.url}" 
               alt="${image.alt || ''}"
               loading="lazy"
               width="128"
               height="128">
        `;
        thumb.innerHTML = thumbImageHtml;

        // Insert beside the featured media wherever it currently lives. While
        // Flickity is active that is inside .flickity-slider, and reInit()
        // moves those children back out preserving their order.
        if (slideAnchor && slideAnchor.parentNode) {
          slideAnchor.parentNode.insertBefore(slide, slideAnchor.nextSibling);
        } else {
          this.productSlider.appendChild(slide);
        }
        slideAnchor = slide;

        if (thumbnails) {
          if (thumbAnchor && thumbAnchor.parentNode) {
            thumbAnchor.parentNode.insertBefore(thumb, thumbAnchor.nextSibling);
          } else {
            thumbnails.appendChild(thumb);
          }
          thumbAnchor = thumb;
        }

        this.currentMetafieldImages.push({ slide, thumb });
      });

      // Videos belong after featured + metafield images.
      this.moveProductVideosToEnd();

      // Don't reinitialize here - let updateMedia() handle it
      // This prevents double reinitialization and ensures the featured media is properly selected
    }

    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let activeMedia = productSlider.querySelector(mediaId);
      if (productSlider.flkty && this.hideVariants) {

        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        
        // Only selected variant featured media (+ metafield images + videos) stay active
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        if (this.currentMetafieldImages) {
          this.currentMetafieldImages.forEach(item => {
            if (item.slide) {
              item.slide.classList.add('is-active');
            }
          });
        }

        this.activateProductVideos();
        this.setImageSetMedia();
        // Re-assert videos after image-set filtering, then pin them last.
        this.activateProductVideos();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          [].forEach.call(thumbnails.querySelectorAll('.product-thumbnail'), function (el) {
            el.classList.remove('is-active');
            el.classList.remove('is-initial-selected');
          });

          if (activeThumb) {
            activeThumb.classList.add('is-active');
            activeThumb.classList.add('is-initial-selected');
          }

          if (this.currentMetafieldImages) {
            this.currentMetafieldImages.forEach(item => {
              if (item.thumb) {
                item.thumb.classList.add('is-active');
              }
            });
          }

          this.activateProductVideoThumbnails(thumbnails);
        }

        this.moveProductVideosToEnd();

        // Only reInit if we haven't already done so (to avoid double reinitialization)
        if (!this._skipReInit) {
        productSlider.reInit(this.imageSetIndex);
        }
        productSlider.flkty.selectCell(mediaId);

      } else if (productSlider.flkty) {
        productSlider.flkty.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

     getVariantSeoData() {
      if (!this.currentVariant) return null;
      const productId =
        this.currentVariant.product_id ||
        (window.theme && theme.settings && theme.settings.product_id);
      const script =
        (productId && document.getElementById(`ProductVariantSeo-${productId}`)) ||
        document.querySelector('script[id^="ProductVariantSeo-"]');
      if (!script) return null;
      if (!this._variantSeoData) {
        try {
          this._variantSeoData = JSON.parse(script.textContent.trim() || '{}');
        } catch (e) {
          this._variantSeoData = {};
        }
      }
      const id = this.currentVariant.id;
      return this._variantSeoData[id] || this._variantSeoData[String(id)] || null;
    }
    setMetaContent(selector, content, attribute = 'content') {
      if (content == null || content === '') return;
      let el = document.querySelector(selector);
      if (!el && selector === 'meta[name="description"]') {
        el = document.createElement('meta');
        el.setAttribute('name', 'description');
        document.head.appendChild(el);
      }
      if (el) el.setAttribute(attribute, content);
    }
    updateDocumentSeo() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      const seo = this.getVariantSeoData();
      if (!seo) return;
      if (seo.title) {
        document.title = seo.title;
        this.setMetaContent('meta[property="og:title"]', seo.title);
        this.setMetaContent('meta[name="twitter:title"]', seo.title);
      }
      if (seo.description != null && seo.description !== '') {
        this.setMetaContent('meta[name="description"]', seo.description);
        this.setMetaContent('meta[property="og:description"]', seo.description);
        this.setMetaContent('meta[name="twitter:description"]', seo.description);
      }
      if (seo.url) {
        const canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) canonical.setAttribute('href', seo.url);
        this.setMetaContent('meta[property="og:url"]', seo.url);
      }
      if (seo.image) {
        this.setMetaContent('meta[property="og:image"]', seo.image.replace(/^https:/, 'http:'));
        this.setMetaContent('meta[property="og:image:secure_url"]', seo.image);
      }
      if (seo.schema) {
        const productId =
          this.currentVariant.product_id ||
          (window.theme && theme.settings && theme.settings.product_id);
        const schemaScript =
          (productId && document.getElementById(`ProductSchema-${productId}`)) ||
          document.querySelector('script[data-product-schema]');
        if (schemaScript) {
          schemaScript.textContent = JSON.stringify(seo.schema);
        }
      }
    }


    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updateBloomreachAddToCartAttrs() {
      if (!this.currentVariant) return;

      const sku =
        (this.currentVariant.sku && String(this.currentVariant.sku).trim()) ||
        String(this.currentVariant.id);
      const productId = this.currentVariant.product_id
        ? String(this.currentVariant.product_id)
        : null;

      document
        .querySelectorAll('.single-add-to-cart-button[data-blm-add-to-cart]')
        .forEach((button) => {
          button.setAttribute('data-blm-add-to-cart-sku', sku);
          if (productId) {
            button.setAttribute('data-blm-add-to-cart-prod-id', productId);
          }
        });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--mobile`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            if (id.includes('price') && destination) {
              destination.classList.remove('visibility-hidden');
            }

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }

        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_mobile = document.getElementById(`price-${this.dataset.section}--mobile`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
      if (price_mobile) price_mobile.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.usesOptionValues()) {
        this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.fieldsets.forEach((fieldset) => {
          fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
            input.classList.toggle(
              'is-disabled',
              input.dataset.available === 'false'
            );
          });
          fieldset.querySelectorAll('option').forEach((option) => {
            option.disabled = option.dataset.available === 'false';
          });
        });
        return true;
      }

      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option) => {
                const optionEl = fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']');
                if (!optionEl) return;
                optionEl.disabled = !!option.isUnavailable;
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input) => {
                const option = fieldset_options.find((entry) => entry.value === input.value);
                input.classList.toggle('is-disabled', !!(option && option.isUnavailable));
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // If the selected variant exists but is sold out, cross out its option values.
          // Do not apply this when currentVariant is null (invalid combination) — that
          // incorrectly marks valid sibling options (e.g. Strip → 4 ft. x 30 ft.) unavailable.
          if (this.currentVariant && !this.currentVariant.available && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  
handleQuantityRules() {
  const variant = this.currentVariant;
  const sectionId = this.dataset.section;

  // Safety: don't run if no variant yet
  if (!variant) return;

  console.log('RULE OBJECT:', variant.id);

  // Find wrapper (form still needed for input/message)
  const wrapper = document.querySelector(`#product-form-${sectionId}`);
  if (!wrapper) {
    console.log('NO WRAPPER FOUND');
    return;
  }

  // Quantity input
  const input = wrapper.querySelector('#Quantity-' + sectionId);
  if (!input) {
    console.log('NO QUANTITY INPUT FOUND');
    return;
  }

  // IMPORTANT FIX: always query JSON globally (not inside wrapper)
let dataEl = null;

// Try inside wrapper first
if (wrapper) {
  dataEl = wrapper.querySelector('.variant-quantity-data');
}

// Fallback: try closest product container
if (!dataEl) {
  const productContainer = this.closest('.thb-product-detail');
  if (productContainer) {
    dataEl = productContainer.querySelector('.variant-quantity-data');
  }
}

// Final fallback: global (last resort)
if (!dataEl) {
  dataEl = document.querySelector('.variant-quantity-data');
}

if (!dataEl) {
  console.log('NO RULES JSON FOUND ANYWHERE');
  return;
}
  if (!dataEl) {
    console.log('NO RULES JSON FOUND');
    return;
  }

  let rules = {};
  try {
    rules = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.log('JSON PARSE ERROR', e);
    return;
  }

  const rule = rules[variant.id] || { min: 1, step: 1 };

  console.log('RULE DATA:', rule);
  console.log('UOM VALUE:', rule.uom);

  const uom = rule.uom || '';
  const normalizedUom = uom.toString().trim().toUpperCase();

  // Apply min/step/max
  input.setAttribute('min', rule.min || 1);
  input.setAttribute('step', rule.step || 1);

  if (rule.max !== null && rule.max !== undefined && rule.max !== 'null') {
    input.setAttribute('max', rule.max);
  } else {
    input.removeAttribute('max');
  }

  // Reset quantity
  input.value = rule.min || 1;

  // Message handling — ensure the container exists so variant switches can show it
  let message = wrapper.querySelector('.quantity-rule');
  if (!message) {
    message = document.createElement('div');
    message.className = 'quantity-rule';
    message.style.display = 'none';
    wrapper.appendChild(message);
  }

  if (rule.step && rule.step > 1) {
    let text;

    // FT logic (strict + safe)
    if (normalizedUom === 'FT') {
      text = `Sold by the foot in multiples of ${rule.step}`;
    } else {
      text = `Sold in multiples of ${rule.step}`;
    }

    console.log('FINAL MESSAGE:', text);

    message.style.display = 'block';
    message.textContent = text;
  } else {
    message.style.display = 'none';
  }
}
  
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();
      
      // Hide/show navigation buttons based on number of slides
      this.updateNavigationVisibility();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {
      // Before destroying, ensure ALL slides (both regular and metafield) are direct children
      // This is critical - Flickity's destroy() should do this, but we need to be explicit
      // to handle cases where slides might be in different locations
      const flickitySlider = this.querySelector('.flickity-slider');
      if (flickitySlider) {
        // Move all slides from flickity-slider back to this element
        // This preserves the order and ensures Flickity can find them on reinit
        const slidesToMove = Array.from(flickitySlider.children);
        slidesToMove.forEach(slide => {
          this.appendChild(slide);
        });
      }
      
      // Also ensure any slides that are direct children stay as direct children
      // (they should already be, but this ensures consistency)

      this.flkty.destroy();

      this.setOptions();

      // Now all slides should be direct children, and Flickity will find those matching cellSelector
      // The cellSelector is '.product-images__slide.is-active', so only slides with is-active will be included
      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
      
      // Hide/show navigation buttons based on number of slides
      this.updateNavigationVisibility();
      
      // Ensure Flickity has properly initialized and positioned cells
      // This helps prevent issues where multiple slides might be visible
      requestAnimationFrame(() => {
        if (this.flkty && this.flkty.selectedElement) {
          // Ensure only the selected slide is visible
          this.flkty.positionSliderAtSelected();
        }
      });
    }
    
    updateNavigationVisibility() {
      // Count how many active slides there are
      const activeSlides = this.querySelectorAll('.product-images__slide.is-active');
      const slideCount = activeSlides.length;
      
      // Find the navigation container
      const navContainer = this.querySelector('.theme-scroll-nav');
      
      if (navContainer) {
        // Hide navigation if there's only one slide, show it if there are more
        if (slideCount <= 1) {
          navContainer.style.display = 'none';
        } else {
          navContainer.style.display = '';
        }
      }
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      // Prevent rapid clicks that might cause issues
      if (this._selecting) return;
      this._selecting = true;
      
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      
      if (!this.flkty || !this.flkty.cells || this.flkty.cells.length === 0) {
        this._selecting = false;
        return;
      }
      
      // Find the corresponding slide by matching thumbnail ID with slide ID
      const thumbId = thumbnail.id;
      if (thumbId) {
        // Convert Thumb-{section}-{mediaId} to Slide-{section}-{mediaId}
        const slideId = thumbId.replace('Thumb-', 'Slide-');
        
        // Find the slide element
        const slide = this.querySelector('#' + slideId);
        if (slide && slide.classList.contains('is-active')) {
          // Find the cell in Flickity's cells array by matching the element
          const cell = this.flkty.getCell(slide);
          if (cell) {
            // Find which slide index this cell belongs to
            const slideIndex = this.flkty.getCellSlideIndex(cell);
            if (slideIndex !== undefined && slideIndex >= 0) {
              // Use select() with the slide index - this is more reliable
              this.flkty.select(slideIndex, false, false);
              // Wait for Flickity to settle
              const changeHandler = () => {
                this._selecting = false;
                this.flkty.off('settle', changeHandler);
              };
              this.flkty.on('settle', changeHandler);
              setTimeout(() => {
                this._selecting = false;
                this.flkty.off('settle', changeHandler);
              }, 300);
              return;
            }
          }
        }
      }
      
      // Fallback: find the correct index by matching active slides with active thumbnails
      const activeSlides = Array.from(this.querySelectorAll('.product-images__slide.is-active'));
      const activeThumbs = Array.from(this.thumbnails).filter(thumb => thumb.classList.contains('is-active'));
      
      // Find the thumbnail's position in active thumbnails
      const thumbIndex = activeThumbs.indexOf(thumbnail);
      if (thumbIndex >= 0 && thumbIndex < activeSlides.length) {
        const correspondingSlide = activeSlides[thumbIndex];
        if (correspondingSlide) {
          // Find the cell and use select() with index
          const cell = this.flkty.getCell(correspondingSlide);
          if (cell) {
            const slideIndex = this.flkty.getCellSlideIndex(cell);
            if (slideIndex !== undefined && slideIndex >= 0) {
              this.flkty.select(slideIndex, false, false);
              const changeHandler = () => {
                this._selecting = false;
                this.flkty.off('settle', changeHandler);
              };
              this.flkty.on('settle', changeHandler);
              setTimeout(() => {
                this._selecting = false;
                this.flkty.off('settle', changeHandler);
              }, 300);
              return;
            }
          }
        }
      }
      
      // Final fallback to index-based selection
      this.flkty.select(index, false, false);
      this._selecting = false;
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      }));



      let product_drawer = document.getElementById('Product-Modal');

      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.hide();
      }
      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      this.setupObservers();
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}